document.querySelectorAll('[data-gc-hf-gallery]').forEach(function (gallery) {
  var id = gallery.getAttribute('data-gc-hf-gallery');
  var lightbox = document.querySelector('[data-gc-hf-lightbox="' + id + '"]');
  if (!lightbox) return;

  var lbImg = lightbox.querySelector('.gc-hf-lb-img');
  var cap = lightbox.querySelector('.gc-hf-lb-cap');
  var photos = Array.prototype.slice.call(gallery.querySelectorAll('.gc-hf-photo'));
  var current = 0;

  function openAt(i) {
    current = (i + photos.length) % photos.length;
    var photo = photos[current];
    var img = photo.querySelector('img');
    if (img && lbImg) {
      lbImg.src = img.currentSrc || img.src;
      lbImg.alt = img.alt || '';
      lbImg.style.display = '';
    } else if (lbImg) {
      lbImg.removeAttribute('src');
      lbImg.style.display = 'none';
    }
    cap.textContent = photo.getAttribute('data-cap') || '';
    lightbox.classList.add('gc-hf-open');
  }

  photos.forEach(function (photo, i) {
    photo.addEventListener('click', function () { openAt(i); });
  });

  var closeBtn = lightbox.querySelector('.gc-hf-lb-close');
  var prevBtn = lightbox.querySelector('.gc-hf-lb-prev');
  var nextBtn = lightbox.querySelector('.gc-hf-lb-next');
  if (closeBtn) closeBtn.addEventListener('click', function () { lightbox.classList.remove('gc-hf-open'); });
  if (prevBtn) prevBtn.addEventListener('click', function () { openAt(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { openAt(current + 1); });

  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) lightbox.classList.remove('gc-hf-open');
  });
  document.addEventListener('keydown', function (e) {
    if (!lightbox.classList.contains('gc-hf-open')) return;
    if (e.key === 'Escape') lightbox.classList.remove('gc-hf-open');
    if (e.key === 'ArrowRight') openAt(current + 1);
    if (e.key === 'ArrowLeft') openAt(current - 1);
  });
});
